// import 'swiper/css/bundle'
import "swiper/css";
// import "swiper/css/pagination";
import "swiper/css/navigation";
import Swiper from "swiper";
// import { Navigation } from "swiper/modules";

const sliders = document.querySelectorAll(".strategy-steps__cards-mobile");

sliders.forEach((slider, index) => {
  // const prevBtn = slider.closest(".section-testimonials-slider")?.querySelector(".testimonials-prev");
  // const nextBtn = slider.closest(".section-testimonials-slider")?.querySelector(".testimonials-next");

  slider.classList.add(`strategy-steps__cards-mobile-${index}`);
  // if (prevBtn) prevBtn.classList.add(`testimonials-prev-${index}`);
  // if (nextBtn) nextBtn.classList.add(`testimonials-next-${index}`);

  new Swiper(`.strategy-steps__cards-mobile-${index}`, {
    // modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    loop: false,
    // navigation: {
    //   nextEl: nextBtn ? `.testimonials-next-${index}` : null,
    //   prevEl: prevBtn ? `.testimonials-prev-${index}` : null,
    // },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  });
});


const initStrategySteps = () => {
  const sections = document.querySelectorAll("[data-strategy-steps]");
  if (!sections.length) return;

  const collapseSiblings = (cards) => {
    cards.forEach((card) => {
      card.classList.remove("is-active");
      const content = card.querySelector("[data-step-content]");
      const footer = card.querySelector("[data-step-footer]");
      const bgActive = card.querySelector("[data-step-bg-active]");
      const bgInactive = card.querySelector("[data-step-bg-inactive]");
      if (content) content.setAttribute("hidden", "");
      if (footer) footer.setAttribute("hidden", "");
      if (bgActive) bgActive.setAttribute("hidden", "");
      if (bgInactive) bgInactive.removeAttribute("hidden");
    });
  };

  sections.forEach((section) => {
    const cards = section.querySelectorAll("[data-step-card]");
    if (!cards.length) return;

    // Set initial visibility
    cards.forEach((card) => {
      const content = card.querySelector("[data-step-content]");
      const footer = card.querySelector("[data-step-footer]");
      const bgActive = card.querySelector("[data-step-bg-active]");
      const bgInactive = card.querySelector("[data-step-bg-inactive]");
      const isOpen = card.classList.contains("is-active");

      if (content) {
        if (isOpen) {
          content.removeAttribute("hidden");
        } else {
          content.setAttribute("hidden", "");
        }
      }

      if (footer) {
        if (isOpen) {
          footer.removeAttribute("hidden");
        } else {
          footer.setAttribute("hidden", "");
        }
      }

      if (bgActive) bgActive.toggleAttribute("hidden", !isOpen);
      if (bgInactive) bgInactive.toggleAttribute("hidden", isOpen);
    });

    // Click handling
    cards.forEach((card) => {
      card.addEventListener("click", () => {
        if (card.classList.contains("is-active")) return;

        collapseSiblings(cards);
        card.classList.add("is-active");

        cards.forEach((item) => {
          const content = item.querySelector("[data-step-content]");
          const footer = item.querySelector("[data-step-footer]");
          const bgActive = item.querySelector("[data-step-bg-active]");
          const bgInactive = item.querySelector("[data-step-bg-inactive]");
          const isOpen = item === card;

          if (bgActive) bgActive.toggleAttribute("hidden", !isOpen);
          if (bgInactive) bgInactive.toggleAttribute("hidden", isOpen);

          if (content) {
            setTimeout(() => {
              if (isOpen) {
                content.removeAttribute("hidden");
              } else {
                content.setAttribute("hidden", "");
              }
            }, 300)
          }

          if (footer) {
            setTimeout(() => {
              if (isOpen) {
                footer.removeAttribute("hidden");
              } else {
                footer.setAttribute("hidden", "");
              }
            }, 300)
          }
        });
      });
    });
  });
};

initStrategySteps();
